import { render } from "./App.vue?vue&type=template&id=c26edda8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=c26edda8&lang=css"

import exportComponent from "/Users/xiaominghui/Desktop/工作/D1M/website-urlscheme/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__